!(function () {
    "use strict";
    customElements.get("recently-viewed") ||
        customElements.define(
            "recently-viewed",
            class extends HTMLElement {
                constructor() {
                    super(), (this.section = this.closest("related-products")), (this.sectionId = this.section?.dataset.sectionId), (this.howManyToShow = parseInt(this.dataset.limit) || 3);
                }
                connectedCallback() {
                    Shopify.Products.showRecentlyViewed({
                        howManyToShow: this.howManyToShow,
                        wrapperId: `recently-viewed-products-${this.sectionId}`,
                        section: this.section,
                        onComplete: (e) => {
                            e.parentElement.dispatchEvent(new CustomEvent("theme:recently-viewed:loaded", { bubbles: !1 }));
                        },
                    });

                    const desktopPerView = Number(this.section.dataset.desktopperview || 1);
                    const mobilePerView  = Number(this.section.dataset.mobileperview  || 1);
                    const desktopEnable  = String(this.section.dataset.desktopsliderenable).toLowerCase() === 'true';
                    const mobileEnable   = String(this.section.dataset.mobilesliderenable).toLowerCase() === 'true';

                    const containerSel = `.recently-viewed-product-${this.sectionId}`;
                    const containerEl  = this.section.querySelector(containerSel);
                    const nextEl       = this.section.querySelector('.swiper-button-next');
                    const prevEl       = this.section.querySelector('.swiper-button-prev');
                    const paginationEl = this.section.querySelector('.swiper-pagination');

                    console.log("containerEl=="+containerEl);
                    let swiper = null;

                    const cfg = {
                    spaceBetween: 5,
                    slidesPerView: mobilePerView,
                    breakpoints: {
                        0:   { 
                            slidesPerView: mobilePerView ,
                            spaceBetween: 5,
                        },
                        769: { 
                            slidesPerView: desktopPerView ,
                            spaceBetween: 20,
                        },
                    },
                    pagination: { el: paginationEl, clickable: true },
                    navigation: { nextEl, prevEl },
                    };

                    const showControls = (show) => {
                    [nextEl, prevEl, paginationEl].forEach(el => { if (el) el.style.display = show ? '' : 'none'; });
                    };

                    const updateSwiper = () => {
                    const isDesktop = window.innerWidth >= 769;
                    const shouldEnable = isDesktop ? desktopEnable : mobileEnable;

                    if (shouldEnable) {
                        if (!swiper || swiper.destroyed) swiper = new Swiper(containerEl, cfg);
                        showControls(true);
                    } else {
                        if (swiper && !swiper.destroyed) { swiper.destroy(true, true); swiper = null; }
                        showControls(false);
                    }
                    };

                    updateSwiper();

                    let rAF;
                    window.addEventListener('resize', () => {
                    cancelAnimationFrame(rAF);
                    rAF = requestAnimationFrame(updateSwiper);
                    });
                }
            }
        );
})();
